import { getDefaultTranslationKey } from '../helpers/ErrorHelper';
import { showErrorMessage } from '../dialogs';

export default {
    methods: {
        showDefaultErrorMessage(statusCode, ...args) {
            const key = getDefaultTranslationKey(statusCode);
            showErrorMessage(this.trans(key), ...args);
        }
    }
};